<!-- 指定id下文件夹列表 -->

<template>
  <Layout>
    <div class="back-view">
      <!--        <div style="-->
      <!--            justify-content: center;-->
      <!--            align-items: center;-->
      <!--            display: flex;-->
      <!--            flex-direction: column;-->
      <!--            padding-left: 20px;-->
      <!--          ">-->
      <!--          <div class="top-view">-->
      <!--            <el-select @change="activityBigTypeChange()" v-model="activityType" placeholder="接龙类型" clearable>-->
      <!--              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">-->
      <!--              </el-option>-->
      <!--            </el-select>-->
      <!--            <el-select v-model="sortType" placeholder="发布时间" clearable style="margin-left: 10px"-->
      <!--              @change="sortTypeChange()">-->
      <!--              <el-option v-for="item in timeoptions" :key="item.value" :label="item.label" :value="item.value">-->
      <!--              </el-option>-->
      <!--            </el-select>-->
      <!--          </div>-->
      <!--        </div>-->
      <div class="type-view">
        <div>
          {{ folderName }}
        </div>

        <div class="createFloderClass" v-if="!batchEditMode">
          <el-button
            plain
            type="primary"
            size="small"
            style="margin-left: 10px"
            @click="quickRelease"
            > <i class="el-icon-plus"></i> 快速发布</el-button
          >
          <el-button
            type="primary"
            size="small"
            style="margin-left: 10px"
            @click="shareclick"
            >分享</el-button
          >
          <el-dropdown trigger="click" @mousedown.stop @click.stop>
            <el-button type="primary" size="small" style="margin-left: 10px"
              >管理</el-button
            >
            <el-dropdown-menu slot="dropdown" @mousedown.stop @click.stop>
              <!-- 文件夹操作 -->
              <el-dropdown-item
                icon="el-icon-edit-outline"
                @click.native="renameFolder()"
                >重命名</el-dropdown-item
              >
              <el-dropdown-item
                icon="el-icon-edit"
                @click.native="batchEditFolder()"
                >批量移动、删除</el-dropdown-item
              >
              <el-dropdown-item
                icon="el-icon-delete"
                @click.native="deleteFolder()"
                >删除文件夹</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="createFloderClass" v-if="batchEditMode">
          <el-button
            type="primary"
            size="small"
            style="margin-left: 10px"
            @click="batchMove"
            >移动</el-button
          >
          <el-button
            type="danger"
            plain
            size="small"
            style="margin-left: 5px"
            @click="batchDelete"
            >删除</el-button
          >
          <el-button
            plain
            size="small"
            style="margin-left: 10px"
            @click="batchEditMode = false"
            >取消</el-button
          >
        </div>
      </div>

      <!-- style="max-width: 1080px" -->

      <div class="list-back-view">
        <el-table
          :header-cell-style="headerCellStyle"
          :data="tableData"
          :row-key="(row) => row.id || row.folderId"
          v-if="tableData"
          @selection-change="handleSelectionChange"
          @row-click="handleRowClick"
        >
          <template slot="empty">
            <div style="margin-top: 50px">
              <img
                src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/tjfx-nodata.svg"
                alt=""
              />
            </div>
            <span>暂无数据</span>
          </template>
          <!-- 多选框列，批量编辑时显示 -->
          <el-table-column
            type="selection"
            width="55"
            v-if="batchEditMode && tableData.some((item) => !item.is_folder)"
            :selectable="selectableRow"
          ></el-table-column>
          <el-table-column prop="activity_type_name" width="80" align="center">
            <template slot="header">
              <span> 类型 </span>
            </template>
            <template slot-scope="scope">
              <template>
                <div
                  class="jlclass"
                  v-show="
                    scope.row.activity_type != 109 &&
                    scope.row.activity_type != 110 &&
                    scope.row.activity_type != 104 &&
                    scope.row.activity_big_type == 1
                  "
                >
                  通用场景
                </div>
                <div
                  class="dkclass"
                  v-show="
                    scope.row.activity_type == 109 ||
                    scope.row.activity_type == 110 ||
                    scope.row.activity_type == 104
                  "
                >
                  打卡签到
                </div>
                <div
                  class="tzclass"
                  v-show="
                    scope.row.activity_type == 201 &&
                    scope.row.activity_big_type == 2
                  "
                >
                  通知公告
                </div>
                <div class="hyclass" v-show="scope.row.activity_type == 303">
                  信息核验
                </div>
              </template>
            </template>
          </el-table-column>

          <el-table-column
            prop="name"
            label="标题"
            min-width="160"
            align="center"
          >
            <template slot-scope="scope">
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  cursor: pointer;
                "
              >
                <!-- 普通活动 -->
                <template>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="scope.row.name"
                    placement="top"
                  >
                    <p style="margin-bottom: 0; color: #1877ff; cursor: pointer" class="hover-underline" @click.stop="nameClick(scope.row)">{{ scope.row.name }}</p>
                  </el-tooltip>
                </template>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            width="80"
            align="center"
            label="状态"
            prop="active_state"
          >
            <template slot-scope="scope">
              <div v-if="recordType != 4">
                <div
                  :class="{
                    nobegin: scope.row.active_state == 1,
                    alreadyend: scope.row.active_state == 2,
                    going: scope.row.active_state == 3,
                  }"
                  v-if="scope.row.is_draft == 0"
                >
                  <p v-if="scope.row.active_state == 1">未开始</p>
                  <p v-if="scope.row.active_state == 2">已结束</p>
                  <p v-if="scope.row.active_state == 3">进行中</p>
                </div>
                <div
                  class="cgclass"
                  v-if="scope.row.is_draft == 1 && scope.row.is_draft"
                >
                  草稿
                </div>
              </div>
              <div
                :class="{
                  nobegin: scope.row.active_state == 1,
                  alreadyend: scope.row.active_state == 2,
                  going: scope.row.active_state == 3,
                }"
                v-if="recordType == 4"
              >
                <div v-if="scope.row.active_state == 1">未开始</div>
                <div v-if="scope.row.active_state == 2">已结束</div>
                <div v-if="scope.row.active_state == 3">进行中</div>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            prop="begin_time"
            label="创建时间"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="end_time"
            label="结束时间"
            align="center"
          ></el-table-column>

          <el-table-column
            prop="sign_num"
            label="参与人数"
            align="center"
            width="120"
          >
            <template slot-scope="scope">
              <span
                style="
                  text-decoration: underline;
                  color: #3e7bfa;
                  cursor: pointer;
                "
                @click="joinClick(scope.row)"
                >{{ scope.row.sign_num }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="177"
            align="center"
          >
            <template slot-scope="scope">
              <template v-if="scope.row.is_draft == 1 && scope.row.is_draft">
                <el-button
                  icon="el-icon-edit"
                  style="margin-right: 10px; color: #1877ff; font-size: 14px"
                  type="text"
                  size="small"
                  @click.stop="dropdownSet(scope.row)"
                  >编辑</el-button
                >
                <el-button
                  style="margin-right: 10px; color: #1877ff; font-size: 14px"
                  type="text"
                  size="small"
                  icon="el-icon-delete"
                  @click.stop="dropdownDel(scope.row)"
                  >删除</el-button
                >
              </template>
              <template v-else>
                <el-button
                  icon="el-icon-share"
                  style="margin-right: 10px; color: #1877ff; font-size: 14px"
                  type="text"
                  size="small"
                  @click.stop="shareClick(scope.row)"
                  >分享{{ scope.index }}</el-button
                >
                <el-dropdown trigger="click" @mousedown.stop @click.stop>
                <el-button
                  type="text"
                  icon="el-icon-setting"
                  style="color: #1877ff; font-size: 14px"
                  class="el-dropdown-link"
                  @click.stop
                >
                  管理
                </el-button>
                <el-dropdown-menu slot="dropdown" @mousedown.stop @click.stop>
                  <!-- 我的发布 -->
                  <template v-if="recordType == 1">
                    <!-- 打卡签到 -->
                    <template
                      v-if="
                        scope.row.activity_type == 109 ||
                        scope.row.activity_type == 110 ||
                        scope.row.activity_type == 104
                      "
                    >
                      <el-dropdown-item
                        icon="el-icon-edit"
                        @click.native="dropdownSet(scope.row)"
                        >编辑</el-dropdown-item
                      >
                      <el-dropdown-item
                        icon="el-icon-user-solid"
                        @click.native="setAdmin(scope.row)"
                        >设置管理员</el-dropdown-item
                      >
                      <el-dropdown-item
                        icon="el-icon-link"
                        @click.native="exportData(scope.row)"
                        >导出数据</el-dropdown-item
                      >
                      <el-dropdown-item
                        icon="el-icon-data-analysis"
                        @click.native="toPageStatistics(scope.row)"
                        >数据统计</el-dropdown-item
                      >
                      <el-dropdown-item
                        icon="el-icon-data-analysis"
                        @click.native="goSupplementCard(scope.row)"
                        >去补卡</el-dropdown-item
                      >
                      <el-dropdown-item
                        icon="el-icon-document-copy"
                        @click.native="dropdownCopy(scope.row)"
                        >复制</el-dropdown-item
                      >
                      <el-dropdown-item
                        v-show="
                          scope.row.active_state == 1 ||
                          scope.row.active_state == 2 ||
                          scope.row.active_state == 3
                        "
                        icon="el-icon-switch-button"
                        @click.native="dropdownEnd(scope.row)"
                        >{{
                          scope.row.active_state == 1
                            ? "立即开始"
                            : scope.row.active_state == 2
                            ? "重启活动"
                            : scope.row.active_state == 3
                            ? "提前结束"
                            : ""
                        }}</el-dropdown-item
                      >
                    </template>
                    <!-- 通知公告、通用接龙 -->
                    <template v-else>
                      <el-dropdown-item
                        icon="el-icon-edit"
                        @click.native="dropdownSet(scope.row)"
                        >编辑</el-dropdown-item
                      >
                      <el-dropdown-item
                        icon="el-icon-user-solid"
                        @click.native="setAdmin(scope.row)"
                        >设置管理员</el-dropdown-item
                      >
                      <el-dropdown-item
                        icon="el-icon-link"
                        @click.native="exportData(scope.row)"
                        >导出数据</el-dropdown-item
                      >
                      <el-dropdown-item
                        icon="el-icon-data-analysis"
                        @click.native="toPageStatistics(scope.row)"
                        >数据统计</el-dropdown-item
                      >
                      <el-dropdown-item
                        icon="el-icon-document-copy"
                        @click.native="dropdownCopy(scope.row)"
                        >复制</el-dropdown-item
                      >
                      <el-dropdown-item
                        v-show="
                          scope.row.active_state == 1 ||
                          scope.row.active_state == 2 ||
                          scope.row.active_state == 3
                        "
                        icon="el-icon-switch-button"
                        @click.native="dropdownEnd(scope.row)"
                        >{{
                          scope.row.active_state == 1
                            ? "立即开始"
                            : scope.row.active_state == 2
                            ? "重启活动"
                            : scope.row.active_state == 3
                            ? "提前结束"
                            : ""
                        }}</el-dropdown-item
                      >
                    </template>
                    <el-dropdown-item
                      icon="el-icon-delete"
                      @click.native="dropdownDel(scope.row)"
                      >删除</el-dropdown-item
                    >
                  </template>
                  <!-- 我的参与 -->
                  <template v-else-if="recordType == 4">
                    <el-dropdown-item
                      icon="el-icon-document-copy"
                      @click.native="dropdownCopy(scope.row)"
                      >复制</el-dropdown-item
                    >
                    <el-dropdown-item
                      v-if="
                        scope.row.activity_type == 109 ||
                        scope.row.activity_type == 110 ||
                        scope.row.activity_type == 104
                      "
                      icon="el-icon-data-analysis"
                      @click.native="dropdownSet(scope.row)"
                      >去补卡</el-dropdown-item
                    >
                  </template>
                  <!-- 我的管理 -->
                  <template v-else-if="recordType == 5">
                    <el-dropdown-item
                      icon="el-icon-edit"
                      @click.native="dropdownSet(scope.row)"
                      >编辑</el-dropdown-item
                    >
                    <el-dropdown-item
                      icon="el-icon-link"
                      @click.native="exportData(scope.row)"
                      >导出数据</el-dropdown-item
                    >
                    <el-dropdown-item
                      icon="el-icon-data-analysis"
                      @click.native="toPageStatistics(scope.row)"
                      >数据统计</el-dropdown-item
                    >
                    <el-dropdown-item
                      v-if="
                        scope.row.activity_type == 109 ||
                        scope.row.activity_type == 110 ||
                        scope.row.activity_type == 104
                      "
                      icon="el-icon-data-analysis"
                      @click.native="goSupplementCard(scope.row)"
                      >去补卡</el-dropdown-item
                    >
                    <el-dropdown-item
                      icon="el-icon-document-copy"
                      @click.native="dropdownCopy(scope.row)"
                      >复制</el-dropdown-item
                    >
                  </template>
                </el-dropdown-menu>
              </el-dropdown>
              </template>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div
        style="text-align: center; margin-top: 20px"
        v-show="tablePage.total"
      >
        <el-pagination
          background
          layout="sizes,prev, pager, next,total"
          :page-sizes="[20, 50, 100, 200]"
          :total="tablePage.total"
          :current-page="tablePage.pageNum"
          :page-size="tablePage.pageSize"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        >
        </el-pagination>
      </div>
    </div>

    <el-dialog
      :title="shareTitle"
      custom-class="dialogClass"
      :visible.sync="dialogVisible"
      width="455px"
      center
    >
      <div
        style="
          text-align: center;

          background-color: #f6f7fa;

          padding-top: 0px;

          padding-bottom: 30px;
        "
      >
        <div class="radioBack">
          <el-radio-group v-model="shareChange" fill="#409eff">
            <el-radio-button
              border="false"
              label="下载接龙二维码"
            ></el-radio-button>

            <el-radio-button
              border="false"
              label="嵌入公众号/文章"
            ></el-radio-button>
          </el-radio-group>
        </div>

        <div v-show="shareChange == '下载接龙二维码'">
          <div>
            <el-image :src="codeUrl" class="code-image"></el-image>
          </div>

          <el-button
            @click="downLoadCodePic(codeUrl)"
            type="primary"
            round
            style="margin-top: 40px"
            >下载接龙二维码</el-button
          >

          <p style="text-align: left; margin-left: 20px; font-weight: 400">
            活动链接
          </p>

          <div
            style="
              background-color: white;

              margin: 10px;

              height: 76px;

              margin-left: 20px;

              margin-right: 20px;
            "
          >
            <p
              style="
                padding: 5px;

                font-size: 12px;

                text-align: left;

                margin-left: 5px;

                /* padding-top: 10px; */
              "
            >
              {{ JumpUrl }}
            </p>

            <button
              style="
                cursor: pointer;

                background-color: rgb(64, 158, 255);

                color: white;

                font-size: 12px;

                width: 50px;

                height: 28px;

                border-radius: 11px;

                margin-top: -10px;

                margin-left: 300px;

                border: none;
              "
              @click="copyClick(JumpUrl)"
            >
              复制
            </button>
          </div>
        </div>

        <div v-show="shareChange != '下载接龙二维码'" class="wzClass">
          <div
            style="
              width: 330px;

              height: 85px;

              background-color: white;

              border-radius: 5px;

              margin: 10px;

              padding: 10px;

              margin-left: 10px;

              /* margin-top: 20px; */
            "
          >
            <div style="display: flex">
              <span
                style="
                  color: #474747;

                  font-weight: 300;

                  width: 83px;

                  text-align: left;
                "
                >小程序ID:</span
              >

              <span
                style="
                  color: #010100;

                  font-weight: 400;

                  width: 200px;

                  text-align: left;
                "
                >{{ appid }}</span
              >
            </div>

            <div
              style="
                display: flex;

                justify-content: space-between;

                margin-left: 0px;

                margin-top: 15px;
              "
            >
              <div>
                <span style="color: red; line-height: 28px; text-align: left"
                  >*</span
                >

                <span
                  style="
                    color: #409eff;

                    font-size: 12px;

                    font-weight: 400;

                    line-height: 28px;

                    text-align: left;
                  "
                  >关联小程序时使用</span
                >
              </div>

              <el-button
                size="mini"
                round
                type="primary"
                @click="copyClick(appid)"
              >
                复制
              </el-button>
            </div>
          </div>

          <div
            style="
              width: 330px;

              height: 85px;

              background-color: white;

              border-radius: 5px;

              margin: 10px;

              padding: 10px;

              margin-left: 10px;
            "
          >
            <div style="display: flex">
              <span
                style="
                  color: #474747;

                  font-weight: 300;

                  width: 83px;

                  text-align: left;
                "
                >页面路径:</span
              >

              <span
                style="
                  color: #010100;

                  font-weight: 400;

                  width: 200px;

                  text-align: left;
                "
                >{{ faceUrl }}</span
              >
            </div>

            <div
              style="
                display: flex;

                justify-content: space-between;

                margin-left: 0px;

                margin-top: 15px;
              "
            >
              <div>
                <span style="color: red; line-height: 28px; text-align: left"
                  >*</span
                >

                <span
                  style="
                    color: #409eff;

                    font-size: 12px;

                    font-weight: 400;

                    line-height: 28px;

                    text-align: left;
                  "
                  >嵌入菜单，文章，回复时使用</span
                >
              </div>

              <el-button
                size="mini"
                round
                type="primary"
                @click="copyClick(faceUrl)"
              >
                复制
              </el-button>
            </div>
          </div>

          <div
            style="
              width: 330px;

              background-color: white;

              border-radius: 5px;

              margin: 10px;

              padding: 10px;

              margin-left: 10px;
            "
          >
            <div
              style="
                text-align: center;

                font-size: 20px;

                font-weight: 500;

                margin-top: 10px;
              "
            >
              使用教程
            </div>

            <div style="margin-top: 10px; margin-bottom: 10px">
              <button
                style="cursor: pointer"
                :class="isAcive == '嵌入到公众号' ? 'acStyle' : 'defStyle'"
                @click="clickHandler"
              >
                嵌入到公众号
              </button>

              <button
                style="cursor: pointer"
                :class="isAcive == '嵌入到文章' ? 'acStyle' : 'defStyle'"
                @click="clickHandler"
              >
                嵌入到文章
              </button>

              <!-- kEu47kwFr2oOr9rO/modularImg/1707035652084.jpg -->
            </div>

            <div v-show="isAcive == '嵌入到公众号'">
              <el-image
                style="width: 300px"
                :src="require('@/assets/images/qrgzh.jpg')"
              >
              </el-image>
            </div>

            <div v-show="isAcive == '嵌入到文章'">
              <el-image
                style="width: 300px"
                :src="
                  imageUrl + 'kEu47kwFr2oOr9rO/modularImg/1707035652084.jpg'
                "
              >
              </el-image>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 新建文件夹对话框 -->
    <el-dialog
      :title="foldertype == 1 ? '新建文件夹' : '重命名'"
      :visible.sync="showCreateFolderDialog"
      width="400px"
      @close="refolderName = ''"
    >
      <el-input
        v-model="refolderName"
        placeholder="请输入文件夹名称"
        maxlength="30"
        show-word-limit
        clearable
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showCreateFolderDialog = false">取 消</el-button>
        <el-button type="primary" @click="createFolder">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 移动文件夹对话框-->
    <el-dialog
      title="选择文件夹"
      :visible.sync="moveDialogVisible"
      width="400px"
      @close="
        moveFolderId = '';
        moveType = 2;
      "
      center
    >
      <el-radio-group v-model="moveType" style="margin-bottom: 16px">
        <el-radio :label="1">新建文件夹</el-radio>
        <el-radio :label="2">现有文件夹</el-radio>
      </el-radio-group>
      <div v-if="moveType === 1">
        <el-input
          v-model="folderName"
          placeholder="请输入文件夹名称"
          maxlength="30"
          show-word-limit
          clearable
        >
        </el-input>
      </div>
      <div v-if="moveType === 2">
        <el-radio-group
          v-model="moveFolderId"
          class="folder-radio-group"
          style="width: 100%"
        >
          <div
            style="width: 100%"
            v-for="folder in folderList"
            :key="folder.id"
            class="folder-radio-item folder-radio-item-custom"
            @click="moveFolderId = folder.id"
            :class="{ 'is-checked': moveFolderId === folder.id }"
          >
            <i
              class="el-icon-folder"
              style="font-size: 18px; margin-right: 8px; vertical-align: middle"
              v-if="folder.id != 0"
            ></i>
            <span style="vertical-align: middle; font-size: 14px">{{
              folder.folderName
            }}</span>
            <span class="custom-radio-circle">
              <span class="circle-outer">
                <span
                  class="circle-inner"
                  v-if="moveFolderId === folder.id"
                ></span>
              </span>
            </span>
          </div>
        </el-radio-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="moveDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmMove">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="manageTitle"
      custom-class="dialogClass"
      :visible.sync="manageDialogVisible"
      width="455px"
      center
    >
      <div
        style="
          text-align: center;
          background-color: #f6f7fa;
          padding-top: 0px;
          padding-bottom: 30px;
        "
      >
        <div>
          <el-image :src="codeUrl" class="code-image"></el-image>
        </div>
        <div>{{ manageTip }}</div>
        <el-button
          @click="downLoadCodePic(codeUrl)"
          type="primary"
          round
          style="margin-top: 40px"
          >下载接龙二维码</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :title="shareTitle"
      custom-class="dialogClass"
      :visible.sync="folderdialogVisible"
      width="455px"
      center
    >
      <div
        style="
          text-align: center;
          background-color: #f6f7fa;
          padding-top: 0px;
          padding-bottom: 30px;
        "
      >
        <div>
          <div>
            <el-image :src="codeUrl" class="code-image"></el-image>
          </div>
          <el-button
            @click="downLoadCodePic(codeUrl)"
            type="primary"
            round
            style="margin-top: 40px"
            >下载接龙二维码</el-button
          >
        </div>
      </div>
    </el-dialog>
  </Layout>
</template>

<script>
import Vue from "vue";
import appConfig from "@/app.config";
import Layout from "../../layouts/main";
// import router from "../../../router/index";

import {
  delActivity,
  earlyTermination,
  getActivityCode,
  getFolderShareLink,
  getShareLink,
  restartActivity,
  startImmediately,
} from "@/utils/api/activity";

import {
  allFolder,
  create,
  creFolderActivityByAcid,
  delFolderActivityByAcid,
  delTooActivity,
  folderActivityByID,
  folderDetete,
  update,
} from "@/utils/api/folder";
import { imageUrl } from "@/utils/config/commonUrl.js";
import copyrightConfig from "@/utils/config/changeCopyright.js";

/**

   * Basic-table component

   */

export default {
  page(){
    const title = this.folderName + " - 我的接龙" || "我的接龙";
    return {
      title: title,
      meta: [{ name: "description", content: appConfig.description }],
    };
  },
  // page: {

  //   meta: [{ name: "description", content: appConfig.description }],
  // },

  components: { Layout },

  data() {
    return {
      refolderName: "",
      folderdialogVisible: false,

      statusFilter: [
        { text: "全部", value: "" },
        { text: "进行中", value: "3" },
        { text: "未开始", value: "1" },
        { text: "已结束", value: "2" },
        { text: "草稿", value: "draft" },
      ],
      showCreateFolderDialog: false,
      folderName: "",
      folderNameInput: "",
      batchEditMode: false, // 是否批量编辑模式
      selectedRows: [], // 已选中的行
      imageUrl: imageUrl,
      codeUrl: "",
      options: [
        { label: "全部", value: "" },
        { label: "接龙", value: 106 },
        { label: "打卡", value: 109 },
      ],
      timeoptions: [
        { label: "由近及远", value: 1 },

        { label: "由远及近", value: 2 },
      ],
      tableData: [],
      dialogVisible: false,
      shareChange: "下载接龙二维码",
      appid: "wx61879a43e8f11e76",
      faceUrl: "/page/index/index",
      recordType: 1, //1我的发布   4 我的参加
      items: [
        { label: "我的发布", value: 1 },
        { label: "我的参加", value: 4 },
        { label: "我的管理", value: 5 },
      ],
      activeTag: 1, //1我的发布   4 我的参加
      isAcive: "嵌入到公众号",
      activityType: "", //106 接龙和 109打卡类型
      sortType: 1, //1、倒序 2、正序
      tablePage: {
        pageNum: 1, //
        pageSize: 20,
        total: 0,
      },
      shareTitle: "分享",
      JumpUrl: "", //投票链接
      foldertype: 1, //文件夹类型1创建2重命名
      currentFolderID: "", //当前文件夹ID
      moveDialogVisible: false, // 控制弹窗显示
      moveType: 2, // 1新建 2现有
      moveFolderId: "", // 选中的文件夹id
      folderList: [], // 文件夹列表
      currentFolderId: "", // 当前文件夹ID
      manageDialogVisible: false,
      manageTip: "",
      manageTitle: "",
    };
  },
  computed: {
    headerCellStyle() {
      return {
        background: "#F1F3F8",
        color: "#3A3A3C",
        fontWeight: "bold",
      };
    },
  },
  created() {
    // 获取路由参数中的 folderId
    this.currentFolderId = this.$route.query.folderId || "";
    console.log(this.currentFolderId, "当前文件夹ID");
    this.folderName = this.$route.query.folderName || "";
    this.batchEditMode = this.$route.query.batchEditMode === "true";
    console.log(this.batchEditMode, "批量编辑模式");
    this.getCreateList();

    // console.log(localStorage.getItem("userID"),"用户ID");
  },
  mounted() {
    // 确保标题设置生效
    this.$nextTick(() => {
      this.setPageTitle();
    });
  },
  methods: {
    quickRelease() {
      console.log("快速发布");
      this.$router.push({
        path: "/modelList",
        query: { folderId: this.currentFolderId },
      });
    },
     // 设置页面标题
     setPageTitle() {
      // 根据 AppID 确定后缀
      let suffix = '接龙加加';
      if (copyrightConfig.AppID === "wx7d8daf6d777947a2") {
        suffix = '报名管家';
      }

      if (this.folderName) {
        document.title = `${this.folderName} - 我的接龙 - ${suffix}`;
      } else {
        document.title = `我的接龙 - ${suffix}`;
      }
      console.log(document.title, "document.title");
    },
    toPageStatistics(row) {
      console.log(row, "row");
      this.$router.push({
        path: "/dataStatistics",
        query: { alias: row.activity_key },
      });
    },
    shareclick(row) {
      const scene = "id=" + this.$route.query.folderId;
      getFolderShareLink({
        activityId: this.$route.query.folderId,
        page: "pages-views/folderDetail/folderDetail",
        scene: scene,
      }).then((res) => {
        if (res.status == 1) {
          this.codeUrl = this.imageUrl + res.data.smallCode;
          this.folderdialogVisible = true;
        }
      });
    },
    setAdmin(row) {
      // 获取二维码
      this.fetchActivityCode(row);
      this.manageDialogVisible = true;
      this.manageTitle = "设置管理员";
      this.manageTip = "请扫码进入小程序邀请管理员";
    },
    exportData(row) {
      this.$router.push({
        path: "/exportDataPage",
        query: { alias: row.activity_key },
      });
    },
    //补卡
    goSupplementCard(row) {
      this.fetchActivityCode(row);
      this.manageDialogVisible = true;
      this.manageTitle = "补卡";
      this.manageTip = "请扫码进入小程序补卡";
    },
    handleRowClick(row) {
      if (this.batchEditMode) return;
      // 跳转到活动详情页，带上活动id
      this.$router.push({
        path: "/activityDetails",
        query: { alias: row.activity_key },
      });
    },
    // 点击名称：草稿去编辑（与记录页一致）；普通活动新窗口打开活动详情
    nameClick(row) {
      if (this.batchEditMode) return;
      if (row.is_draft == 1 && row.is_draft) {
        return this.dropdownSet(row);
      }
      const routeData = this.$router.resolve({
        path: "/activityDetails",
        query: { alias: row.activity_key },
      });
      window.open(routeData.href, "_blank");
    },
    batchEditFolder() {
      // 进入批量编辑模式
      this.batchEditMode = true;
      this.selectedRows = [];
    },
    handleSelectionChange(val) {
      console.log(val, "选中的行");
      this.selectedRows = val.map((item) => item.id);
      console.log(this.selectedRows, "选中的文件啊");
    },
    // 批量删除
    batchDelete() {
      if (this.selectedRows.length === 0) {
        this.$message.warning("请选择需要删除的活动");
        return;
      }
      this.$confirm("确定将所选活动放入回收站吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        delTooActivity({
          activityIds: this.selectedRows,
        }).then((res) => {
          console.log(res, "删除接口");
          this.$message({
            type: "success",
            message: "成功!",
          });
          this.getCreateList();
        });
      });
    },
    //批量移动
    async batchMove() {
      if (this.selectedRows.length === 0) {
        this.$message.warning("请选择要移动的活动");
        return;
      }
      // 打开弹窗并拉取文件夹列表
      this.moveDialogVisible = true;
      const res = await allFolder({ userId: localStorage.getItem("userID") });
      if (res.status === 1) {
        res.data.unshift({ folderName: "我的发布(全部)", id: 0 });
        this.folderList = res.data;
        console.log(this.folderList, "文件夹列表");
      }
    },
    async confirmMove() {
      // 如果是新建文件夹，先走创建文件夹接口
      if (this.moveType === 1) {
        const res = await create({ folderName: this.folderName });
        if (res.status === 1) {
          this.moveFolderId = res.data.id;
        } else {
          this.$message.error("新建文件夹失败");
          return;
        }
      }
      // 如果选中的是我的发布，直接将活动移动到我的发布页面
      if (this.moveFolderId == 0) {
        var data = {
          folderId: this.currentFolderId,
          activityIds: this.selectedRows,
        };
        var result = await delFolderActivityByAcid(data);
        if (result.status == 1) {
          this.$message({
            type: "success",
            message: "成功!",
          });
          this.getCreateList();
          this.moveDialogVisible = false;
        }
      } else {
        // 如果没有选择目标文件夹，提示并返回
        if (!this.moveFolderId && this.moveType === 2) {
          this.$message.warning("请选择目标文件夹");
          return;
        }

        // 如果选中的是其他文件夹，将活动移动到目标文件夹
        // TODO: 执行批量移动逻辑
        creFolderActivityByAcid({
          activityIds: this.selectedRows,
          folderId: this.moveFolderId,
        }).then((res) => {
          console.log(res, "移动接口");
          this.$message({
            type: "success",
            message: "成功!",
          });
          this.getCreateList();
        });
        this.moveDialogVisible = false;
      }
    },
    selectableRow(row) {
      // 只有非文件夹行可选
      return !row.is_folder;
    },
    deleteFolder() {
      this.$confirm("删除后文件夹里的活动将会转移到我发布的页", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        folderDetete({
          id: this.currentFolderId,
        }).then((res) => {
          console.log(res, "删除接口");
          this.$message({
            type: "success",
            message: "成功!",
          });
          // 返回上一页
          this.$router.go(-1);
          // this.getAllFolderList();
        });
      });
    },
    renameFolder() {
      this.refolderName = this.folderName;
      this.showCreateFolderDialog = true;
      this.foldertype = 2;
    },

    // 新建文件夹方法
    async createFolder() {
      // 判断输入框是否为空或全是空格
      if (!this.folderName.trim()) {
        this.$message.warning("请输入文件夹名称");
        return;
      }
      // 调用创建文件夹接口
      try {
        // 调用API创建文件夹，传递文件夹名称
        if (this.foldertype == 1) {
          const res = await create({ folderName: this.folderName });
          if (res.status === 1) {
            // 创建成功，提示并关闭弹窗，清空输入框，刷新列表
            this.$message.success("创建成功");
            this.showCreateFolderDialog = false;
            this.refolderName = "";
            // this.getAllFolderList();
          }
        } else {
          const res = await update({
            folderName: this.refolderName,
            id: this.currentFolderId,
          });
          if (res.status === 1) {
            this.$message.success("重命名成功");
            Vue.set(this, "folderName", this.refolderName);
            console.log(this.folderName, "重命名接口");
          }
          // 关闭弹窗并清空输入
          this.showCreateFolderDialog = false;
          // this.refolderName = '';
          this.currentFolderID = "";
          this.foldertype = 1;
        }
      } catch (e) {
        // 接口异常，提示失败
        this.$message.error("创建失败了");
      }
    },
    // async getAllFolderList(){
    //   let result = await allFolder({ userId: localStorage.getItem("userID") });

    // },
    handleTagClick(val) {
      this.activeTag = val;
      this.recordType = val;
      this.getCreateList();
    },
    filterHandler(value, row) {
      console.log(value, row);
    },
    handleSizeChange(pageSize) {
      this.tablePage.pageNum = 1;
      this.tablePage.pageSize = pageSize;
      this.getCreateList();
    },
    handlePageChange(currentPage) {
      this.tablePage.pageNum = currentPage;
      this.getCreateList();
    },

    //切换类型

    activityBigTypeChange() {
      this.getCreateList();
    },

    // 切换时间排序

    sortTypeChange() {
      this.getCreateList();
    },
    handleStatusFilter(command) {
      console.log(command, "command");
      this.statusFilter = command;
      this.getCreateList();
    },
    getCreateList() {
      // 获取当前文件夹下的活动
      folderActivityByID({
        pageSize: this.tablePage.pageSize,
        pageNum: this.tablePage.pageNum,
        folderId: this.currentFolderId,
      }).then((res1) => {
        let activityList = [];
        if (res1.status == 1) {
          activityList = res1.data.list.list;
        }
        this.tablePage.total = res1.data.list.total;
        this.tableData = activityList;
      });
    },
    //展示分享弹窗

    shareClick(row) {
      if (this.batchEditMode) return;
      console.log(row, "row");
      this.shareTitle = "分享" + "    " + "    " + "    " + row.name;
      // 获取二维码
      this.fetchActivityCode(row);
      this.dialogVisible = true;
    },
    // 获取二维码
    fetchActivityCode(row) {
      const scene = "id=" + row.id + "&st=see&ity=" + row.activity_type;
      getActivityCode({
        activityId: row.id,
        page: "pages/solataireGroupDetails/solataireGroupDetails",
        scene: scene,
      }).then((res) => {
        console.log(res, "获取二维码");
        if (res.status == 1) {
          this.codeUrl = this.imageUrl + res.data.smallCode;
          console.log(this.codeUrl, "this.codeUrl");
        }
      });

      getShareLink({ activityId: row.id }).then((res) => {
        if (res.status == 1) {
          this.JumpUrl = res.data.shareLink;
        }
      });
    },

    downLoadCodePic(url) {
      this.downloadIamge(url, new Date().valueOf());
    },

    //

    downloadIamge(imgsrc, name) {
      // 下载图片地址和图片名

      var image = new Image();

      // 解决跨域 Canvas 污染问题

      image.setAttribute("crossOrigin", "Anonymous");

      image.onload = () => {
        var canvas = document.createElement("canvas");

        canvas.width = image.width;

        canvas.height = image.height;

        var context = canvas.getContext("2d");

        context.fillStyle = "#FFFFFF";

        context.fillRect(0, 0, canvas.width, canvas.height);

        context.drawImage(image, 0, 0, image.width, image.height);

        var url = canvas.toDataURL("image/png"); // 得到图片的base64编码数据

        var a = document.createElement("a"); // 生成一个a元素

        var event = new MouseEvent("click"); // 创建一个单击事件

        a.download = name || "photo"; // 设置图片名称

        a.href = url; // 将生成的URL设置为a.href属性

        a.dispatchEvent(event); // 触发a的单击事件
      };

      image.src = imgsrc;
    },

    // 编辑修改

    dropdownSet(row) {
      console.log(row, "去编辑--内容");

      console.log(row.createId != row.user_id);

      console.log(row.is_admin == 2);

      if ((row.createId && row.createId != row.user_id) || row.is_admin == 2) {
        this.$message("没有权限修改");

        return false;
      }

      // this.$router.push({

      //   path: "/solitaire",

      //   query: {

      //     activityId: row.id,

      //     selectType: "update",

      //     isType: row.activity_type,

      //   },

      // });

      this.$router.push({
        path: "/solitaire",

        query: {
          alias: row.activity_key,

          selectType: "update",

          isType: row.activity_type,
        },
      });
    },

    // 提前结束

    dropdownEnd(row) {
      var toastMessage = "";

      if (row.active_state == 1) {
        // 活动未开始

        toastMessage = "是否立即开始该活动";
      } else if (row.active_state == 2) {
        // 活动已结束

        toastMessage = "是否立即重启该活动";
      } else if (row.active_state == 3) {
        // 活动进行中

        toastMessage = "是否提前结束该活动";
      }

      this.$confirm(toastMessage, "提示", {
        confirmButtonText: "确定",

        cancelButtonText: "取消",

        type: "warning",
      })

        .then(() => {
          if (row.active_state == 1) {
            // 活动未开始

            startImmediately({
              id: row.id,
            }).then((res) => {
              console.log(res, "立即开始接口");

              this.$message({
                type: "success",

                message: "成功!",
              });

              this.getCreateList();
            });

            // earlyTermination,restartActivity,startImmediately
          } else if (row.active_state == 2) {
            // 活动已结束

            restartActivity({
              id: row.id,
            }).then((res) => {
              console.log(res, "重启活动接口");

              this.$message({
                type: "success",

                message: "成功!",
              });

              this.getCreateList();
            });
          } else if (row.active_state == 3) {
            // 活动进行中

            console.log("提前结束接口");

            earlyTermination({
              id: row.id,
              is_it_over: 2,
              userId: localStorage.getItem("userID"),
            }).then((res) => {
              console.log(res, "提前结束接口");
              this.$message({
                type: "success",
                message: "成功!",
              });
              this.getCreateList();
            });
          }
        })
        .catch(() => {});
      console.log(row, "row");
    },



    // 复制

    dropdownCopy(row) {
      console.log(row, "row");

      // this.$router.push({

      //   path: "/solitaire",

      //   query: {

      //     activityId: row.id,

      //     selectType: "add",

      //     isType: row.activity_type,

      //     copy: true,

      //   },

      // });

      this.$router.push({
        path: "/solitaire",

        query: {
          alias: row.activity_key,

          selectType: "add",

          isType: row.activity_type,

          copy: true,
        },
      });
    },

    // 删除

    dropdownDel(row) {
      console.log(row, "row");

      if (row.is_draft == 1 && row.is_draft) {
        this.$confirm("确定删除该草稿吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            delActivity({
              activityId: row.id,
            }).then((res) => {
              console.log(res, "删除接口");
              this.$message({
                type: "success",
                message: "成功!",
              });

              this.getCreateList();
            });
          })

          .catch(() => {
            this.$message({
              type: "success",
              message: "取消删除!",
            });
          });
      } else if (row.active_state == 2) {
        this.$confirm("确定删除该活动吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            delActivity({
              activityId: row.id,
            }).then((res) => {
              console.log(res, "删除接口");
              this.$message({
                type: "success",
                message: "成功!",
              });

              this.getCreateList();
            });
          })

          .catch(() => {});
      } else {
        this.$message({
          message: "活动未结束，不可以删除",

          type: "warning",
        });
      }
    },

    copyClick(sender) {
      var input = document.createElement("input"); // 创建input对象

      input.value = sender; // 设置复制内容

      document.body.appendChild(input); // 添加临时实例

      input.select(); // 选择实例内容

      document.execCommand("Copy"); // 执行复制

      document.body.removeChild(input); // 删除临时实例

      this.$message.success("复制成功！");
    },

    joinClick(sender) {
      if (this.batchEditMode) return;
      console.log(sender);

      // eslint-disable-next-line no-case-declarations

      this.$router.push({
        path: "/joinList",

        query: { alias: sender.activity_key, activityName: this.folderName },
      });
    },

    clickHandler(event) {
      this.isAcive = event.target.innerText;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-input--suffix .el-input__inner {
  padding-right: 75px !important;
}
.back-view {
  background-color: #ffffff;

  width: 100%;

  min-height: 500px;

  // justify-content: center;

  // align-items: center;

  // display: flex;

  // flex-direction: column;

  // overflow: auto;
}

.top-view {
  height: 81px;
  display: flex;
  padding-top: 31px;
  // padding-left: 18px;
  width: 100%;
  // max-width: 1100px;
}
.type-view {
  display: flex;
  width: 100%;
  padding: 10px 20px 20px;
  align-items: center;
  justify-content: space-between;
}
.list-back-view {
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 30px;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  overflow: visible !important;
  // min-height: 800px;
}

.el-dropdown-link {
  cursor: pointer;

  color: #409eff;

  font-size: 12px;
}

.el-icon-arrow-down {
  font-size: 10px;
}

.demonstration {
  display: block;

  color: #8492a6;

  font-size: 14px;

  margin-bottom: 20px;
}

.radioBack .el-radio-group {
  border-radius: 40px;

  overflow: hidden;

  border: 1px solid rgb(64, 158, 255);
}

.radioBack .el-radio-button {
  // width: 120px;

  margin: 0;
}

.radioBack .el-radio-button__inner {
  color: rgb(64, 158, 255);

  border: 0px solid rgb(64, 158, 255);

  font-size: 12px;
}

::v-deep .el-radio-button__inner {
  color: rgb(64, 158, 255);
}

.code-image {
  margin-top: 40px;

  width: 200px;

  height: 200px;
}

.acStyle {
  width: 120px;

  height: 30px;

  background-color: rgb(64, 158, 255);

  color: white;

  font-size: 12px;

  border: 0;
}

.defStyle {
  width: 120px;

  height: 30px;

  background-color: white;

  color: rgb(64, 158, 255);

  font-size: 12px;

  border: 1px solid rgb(64, 158, 255);
}

.nobegin {
  margin-top: 2px;

  margin-right: 5px;

  margin-left: 15px;

  font-size: 12px;

  line-height: 19px;

  width: 45px;

  height: 19px;

  background: #fff0f0;

  border: 1px solid #feeaea;

  border-radius: 4px;

  color: #f67a7a;
}

.alreadyend {
  margin-top: 2px;

  margin-right: 5px;

  margin-left: 15px;

  font-size: 12px;

  line-height: 19px;

  width: 45px;

  height: 19px;

  background: #d8d8d8;

  border: 1px solid #d8d8d8;

  border-radius: 4px;

  color: white;
}

.going {
  margin-top: 2px;

  margin-right: 5px;

  margin-left: 15px;

  font-size: 12px;

  line-height: 19px;

  width: 45px;

  height: 19px;

  background: #1bce4a;

  border: 1px solid #1bce4a;

  border-radius: 4px;

  color: white;
}

.cgclass {
  margin-top: 2px;
  margin-right: 5px;
  margin-left: 15px;
  font-size: 12px;
  line-height: 19px;
  width: 45px;
  height: 19px;
  background: #fea951;
  border: 1px solid #fea951;
  border-radius: 4px;
  color: white;
}

.jlclass {
  width: 60px;
  height: 20px;
  background: rgba(81, 111, 240, 0.16);
  border: 1px solid rgba(81, 111, 240, 0.11);
  border-radius: 4px;
  color: #516ff0;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dkclass {
  width: 60px;
  height: 20px;
  background: rgba(85, 167, 253, 0.16);
  border: 1px solid rgba(85, 167, 253, 0.11);
  border-radius: 4px;
  color: #55a7fd;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
}
.tzclass {
  width: 60px;
  height: 20px;
  background: rgba(27, 206, 74, 0.16);
  border: 1px solid rgba(27, 206, 74, 0.11);
  border-radius: 4px;
  color: #55a7fd;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
}

.yhclass {
  width: 60px;
  height: 20px;
  background: rgba(107, 27, 206, 0.16);
  border: 1px solid rgba(107, 27, 206, 0.11);
  border-radius: 4px;
  color: #6b1bce;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
}

.wzClass {
  overflow: auto;
  height: 439px;
  // text-align: center;
  justify-content: center;
  // display: flex;
  // flex-direction: column;
  padding-left: 27px;
  margin-top: 10px;
}
.createFloderClass {
  cursor: pointer;
  height: 38px;
  border-radius: 4px;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  color: #1877ff;
  line-height: 38px;
}
.folder-radio-group .folder-radio-item {
  display: flex;
  align-items: center;
  height: 38px;
  padding: 0 8px;
  border-radius: 4px;
  margin-bottom: 6px;
  transition: background 0.2s;
  border-bottom: 1px solid #ececec;
}
.folder-radio-group .folder-radio-item:last-child {
  border-bottom: none; /* 最后一项不显示下划线 */
}
.folder-radio-group .folder-radio-item:hover {
  background: #f5f7fa;
}
.folder-radio-group .el-radio__input {
  margin-right: 6px;
}
.folder-radio-group .folder-radio-item-custom {
  display: flex;
  align-items: center;
  height: 38px;
  padding-left: 18px;
  padding-right: 18px;
  border-radius: 4px;
  border-bottom: 1px solid #ececec;
  position: relative;
  cursor: pointer;
  transition: background 0.2s;
  margin-bottom: 0;
}
.folder-radio-group .folder-radio-item-custom:last-child {
  border-bottom: none;
}
.folder-radio-group .folder-radio-item-custom:hover {
  background: #f5f7fa;
}
.folder-radio-group .custom-radio-circle {
  margin-left: auto;
  /* 保证右侧留白与左侧一致 */
  display: flex;
  align-items: center;
}
.folder-radio-group .circle-outer {
  width: 18px;
  height: 18px;
  border: 2px solid #333;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
}
.folder-radio-group .circle-inner {
  width: 10px;
  height: 10px;
  background: #409eff;
  border-radius: 50%;
}
.folder-radio-group .is-checked .circle-outer {
  border-color: #409eff;
}

.hover-underline:hover {
  text-decoration: underline;
}
</style>

<style>
.dialogClass {
  border-radius: 9px;
  background: #f8f8f8;
  overflow: hidden;
}
</style>
